"use client";

import { Component, type ReactNode } from "react";
import { getBugsnagClient, initBugsnag } from "@trex-2b/libs/utils/bugsnag";

interface BugsnagErrorBoundaryProps {
  children: ReactNode;
  /** 子树抛错时展示；不传则为 `null`，避免白屏后继续渲染已崩溃的子树 */
  fallback?: ReactNode;
}

interface BugsnagErrorBoundaryState {
  hasError: boolean;
}

initBugsnag();

export class BugsnagErrorBoundary extends Component<
  BugsnagErrorBoundaryProps,
  BugsnagErrorBoundaryState
> {
  state: BugsnagErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): BugsnagErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: { componentStack: string }): void {
    const client = getBugsnagClient();
    if (client) {
      client.notify(error, (event) => {
        event.addMetadata("errorBoundary", {
          componentStack: errorInfo.componentStack,
        });
      });
    }
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return this.props.fallback ?? null;
    }
    return this.props.children;
  }
}
